import z from 'zod'

import { RichPlacementKWordsSlice } from '../../hooks/useGetRichPlacementKWords'

export const schema = z.object({
  kwordsSiteId: z.string().default(''),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({ kwordsSiteId }: RichPlacementKWordsSlice): Schema => ({
  kwordsSiteId: kwordsSiteId ?? '',
})
